export const tiposDeAnticonceptivos = [
  "Anticonceptivos orales combinados (AOC) o «la píldora»",
  "Píldoras con progestágeno solo o «la minipíldora»",
  "Implantes.",
  "Inyectables mensuales o anticonceptivos inyectables combinados (AIC).",
  "Parche anticonceptivo combinado y anillo vaginal anticonceptivo combinado (AVC).",
  "Dispositivo intrauterino (DIU): de cobre.",
  "Dispositivo intrauterino (DIU) de levonorgestrel.",
  "Preservativo masculino.",
  "Preservativo femenino.",
];

export const motivosTomaDeAnticonceptivos = [
  "Anticoncepción",
  "Acné ",
  "Regulación hormonal",
  "Salud del sistema reproductivo (SOP- Endometriosis)",
];

export const metdosAccesoAnticonceptivos = [
    "Compra en droguerías",
    "Provisión por parte de EPS o IPS"
]